import React from 'react';
//import { withRouter } from 'react-router';
import { graphql } from "react-apollo";

import { notes } from '../../graphql/queries';
import { ColHead, ColError, ColLoading } from '../chunk'
import Tile from "../Tile"
import ListItem from '../ListItem'
import { NavLink } from 'react-router-dom';


class NoteList extends React.Component {
	render() {

		let { loading, error, notes } = this.props.data; //error=ApolloError

		if( loading ) return (
          <div className="col col-2"><ColLoading /></div>
        )
	    if( error ) return (
          <div className="col col-2"><ColError error={error} /></div>
        )

		return (
			<div className="col col-2">
                <div className="col__actions">
                    <NavLink to={`/notes/add`} className="col__action">+ new note</NavLink>
                </div>
      			<ColHead icon="sticky-note" title="NOTES" meta={`${notes.length} Notes`} />

                <div className="list">
				{notes.map(({ id, body }) => (
                  <ListItem key={id} url={`/notes/${id}`}>
                    <div className="noteListItem">
                        {body}
                    </div>
                  </ListItem>
                ))}
                </div>
{/* 
		        <div className="grid-list">
				<Tile url={`/notes/add`} text="+ new note" />
				
				{notes.map(({ id, body }) => (
					<Tile key={id} id={id} text={body} url={`/notes/${id}/`} />
				))}
		        </div> */}
		    </div>
      	)
	}
}


export default graphql(notes)(NoteList)


// WEBPACK FOOTER //
// ./src/components/note/NoteList.js